import React from 'react';
import { LadderPopup } from "../components/LadderPopup";
import { CacheableDataObject } from "./CacheableDataObject";
import Infraction from "./Infraction";


export default class InfractionHolder extends CacheableDataObject {
	beforeConstruct() {
		this.infractions = [];
	}

	hasToxicWarning(countThreshold = 1) {
		let count = this.getToxicCount();
		if(!count) {
			return false;
		}
		return count >= countThreshold;
	}

	getToxicCount() {
		return this.infractions.length;
	}

	showToxicWarning() {
		return new Promise((resolve, reject) => {

			let content = (
				<React.Fragment>
					<h3 className='page-sub-heading'> Reported Behavior </h3>
					<h4 className='page-sub-heading'> WE REPEAT THEY WILL PROBABLY DO THIS AGAIN </h4>
					<h5 className='page-sub-heading'> Reports from this player are given a lower priority </h5>
					<ul className='reported_match_behavior warning_popup'>
						{this.infractions.map((infraction) => {
							return (
								<li
									key={infraction.id}
								>
									{infraction.public_message}
								</li>
							);
						})}

					</ul>

				</React.Fragment>
			);
			let warningMessage = null;
			if(this.user) {
				warningMessage = `${this.user.username} has multiple reports, are you sure? Disputes caused by them will not be moderated. <br> DO NOT BE SURPRISED IF THEY INSULT YOU`;
			}
			else {
				warningMessage = 'The user you were matched up has been reported a lot for toxic behavior, you are free to decline without penalty. DO NOT BE SURPRISED IF THEY INSULT/THREATEN YOU AND YOU ACCEPT';
			}

			let popup = LadderPopup.create(content, warningMessage, {
				buttons: [
					{
						className: 'btn-danger',
						text: 'Reject',
						dismiss: true,
						click: (popup) => {
							reject();
						}
					},
					{
						text: 'I have been warned and accept anyway',
						dismiss: false,
						click: (popup) => {
							resolve();
							popup.dismiss();
						}
					}
				]
			});
			popup.onDismiss.then(function() {
				reject();//Hmm.. might happen after other events ^.^
			});
		});
	}
}
InfractionHolder.prototype.dataLocationParsers = {
	infractions: (holder, data) => {
		holder.infractions = Infraction.convert(data.infractions);
	}
};